(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
angular.module('festival', [])
.filter('fromTodayFilter', require('./festival/filters/fromTodayFilter'))
.filter('spreadsheetFilter', require('./festival/filters/spreadsheetFilter'))
.filter('programGuideFilter', require('./festival/filters/programGuideFilter'))
.filter('onlyTodayFilter', require('./festival/filters/onlyTodayFilter'))
.filter('programGuideAfterPlaylistFilter', require('./festival/filters/programGuideAfterPlaylistFilter'))
.filter('instagramJsonFilter', require('./festival/filters/instagramJsonFilter'))
.factory('festivalDataFactory', require('./festival/services/festivalDataFactory'))
.factory('youtubeFactory', require('./festival/services/youtubeFactory'))
.factory('buddiesFactory', require('./festival/services/buddiesFactory'))
.factory('jQuery', require('./festival/services/jquery'))
.factory('facebookFactory', require('./festival/services/facebookFactory'))
.factory('instaFeedFactory', require('./festival/services/instaFeedFactory'))
.factory('instagramFactory', require('./festival/services/instagramFactory'))
.controller('mainStageController', require('./festival/controllers/mainStageController'))
.controller('liveStreamController', require('./festival/controllers/liveStreamController'))
.controller('instagramController', require('./festival/controllers/instagramController'))
.directive('spotify', require('./festival/directives/spotify'))
.directive('youtube', require('./festival/directives/youtube'))
.directive('lenia', require('./festival/directives/lenia'))
.directive('bgSize', require('./festival/directives/bgSize'))
.directive('bgPosition', require('./festival/directives/bgPosition'))
.directive('facebookComment', require('./festival/directives/facebookComment'));

},{"./festival/controllers/instagramController":2,"./festival/controllers/liveStreamController":3,"./festival/controllers/mainStageController":4,"./festival/directives/bgPosition":5,"./festival/directives/bgSize":6,"./festival/directives/facebookComment":7,"./festival/directives/lenia":8,"./festival/directives/spotify":9,"./festival/directives/youtube":10,"./festival/filters/fromTodayFilter":11,"./festival/filters/instagramJsonFilter":12,"./festival/filters/onlyTodayFilter":13,"./festival/filters/programGuideAfterPlaylistFilter":14,"./festival/filters/programGuideFilter":15,"./festival/filters/spreadsheetFilter":16,"./festival/services/buddiesFactory":17,"./festival/services/facebookFactory":18,"./festival/services/festivalDataFactory":19,"./festival/services/instaFeedFactory":20,"./festival/services/instagramFactory":21,"./festival/services/jquery":22,"./festival/services/youtubeFactory":23}],2:[function(require,module,exports){
module.exports = ['$scope', '$filter', 'instagramFactory', '$timeout', function($scope, $filter, instagramFactory, $timeout){

    $scope.add = function(instaId) {
        var feed = instagramFactory.create(instaId, function(response) {
            $timeout(function() {
                $scope.filteredInstaData = $filter('instagramJsonFilter')(response);
            }, 0);
        });

        feed.run();
    }
}
];
},{}],3:[function(require,module,exports){
module.exports = ['$scope', '$filter', '$timeout', 'festivalDataFactory', 'youtubeFactory', 'buddiesFactory', 'facebookFactory', function($scope, $filter, $timeout, festivalDataFactory, youtubeFactory, buddiesFactory, facebookFactory){
	$scope.buddiesData = [];
	
	youtubeFactory.onYouTubeReady(function() {
		buddiesFactory.getData().then(function (response) {
			var data = response.data;
			if (data.length) {
				$scope.buddiesData = data;
			} else {
				$scope.buddiesData = [{"id":1,"status":"offline","youtube_url":"fbOiXEnu3pc","hu_name":"Tricky","hu_description":"Buddy 1 le\u00edr\u00e1sa","en_name":"Buddy 1","en_description":"Buddy 1 le\u00edr\u00e1sa","has_guide":true,"guide":{"hu_name":"Guide 1","hu_description":"Guide 1 le\u00edr\u00e1sa","en_name":"Guide 1","en_description":"Guide 1 le\u00edr\u00e1sa","image":"http:\/\/146.185.148.251\/upload"},"image":""},{"id":2,"status":"offline","youtube_url":"fbOiXEnu3pc","hu_name":"Funky","hu_description":"Buddy 2 le\u00edr\u00e1sa","en_name":"Buddy 2","en_description":"Buddy 2 le\u00edr\u00e1sa","has_guide":true,"guide":{"hu_name":"Guide 2","hu_description":"Guide 2 le\u00edr\u00e1sa","en_name":"Guide 2","en_description":"Guide 2 le\u00edr\u00e1sa","image":"http:\/\/146.185.148.251\/upload"},"image":""},{"id":3,"status":"offline","youtube_url":"fbOiXEnu3pc","hu_name":"Crazy","hu_description":"Buddy 3 le\u00edr\u00e1sa","en_name":"Buddy 3","en_description":"Buddy 3 le\u00edr\u00e1sa","has_guide":true,"guide":{"hu_name":"Guide 3","hu_description":"Guide 3 le\u00edr\u00e1sa","en_name":"Guide 3","en_description":"Guide 3 le\u00edr\u00e1sa","image":"http:\/\/146.185.148.251\/upload"},"image":""}];
			}
		}, function errorCallback(response) {
			$scope.buddiesData = [{"id":1,"status":"offline","youtube_url":"fbOiXEnu3pc","hu_name":"Tricky","hu_description":"Buddy 1 le\u00edr\u00e1sa","en_name":"Buddy 1","en_description":"Buddy 1 le\u00edr\u00e1sa","has_guide":true,"guide":{"hu_name":"Guide 1","hu_description":"Guide 1 le\u00edr\u00e1sa","en_name":"Guide 1","en_description":"Guide 1 le\u00edr\u00e1sa","image":"http:\/\/146.185.148.251\/upload"},"image":""},{"id":2,"status":"offline","youtube_url":"fbOiXEnu3pc","hu_name":"Funky","hu_description":"Buddy 2 le\u00edr\u00e1sa","en_name":"Buddy 2","en_description":"Buddy 2 le\u00edr\u00e1sa","has_guide":true,"guide":{"hu_name":"Guide 2","hu_description":"Guide 2 le\u00edr\u00e1sa","en_name":"Guide 2","en_description":"Guide 2 le\u00edr\u00e1sa","image":"http:\/\/146.185.148.251\/upload"},"image":""},{"id":3,"status":"offline","youtube_url":"fbOiXEnu3pc","hu_name":"Crazy","hu_description":"Buddy 3 le\u00edr\u00e1sa","en_name":"Buddy 3","en_description":"Buddy 3 le\u00edr\u00e1sa","has_guide":true,"guide":{"hu_name":"Guide 3","hu_description":"Guide 3 le\u00edr\u00e1sa","en_name":"Guide 3","en_description":"Guide 3 le\u00edr\u00e1sa","image":"http:\/\/146.185.148.251\/upload"},"image":""}];
		});
	});

	facebookFactory.onFacebookReady(function(){
		try {
			facebookFactory.FB.init({
				appId      : festivalDataFactory.liveStream.facebookAppId,
				xfbml      : true,
				version    : 'v2.3'
			});
		} catch (e) {
			//console.log('facebook api error');
		}
	});
}];

},{}],4:[function(require,module,exports){
module.exports = ['$scope', 'festivalDataFactory', function($scope, festivalDataFactory){
		if(festivalDataFactory.mainStage){
			$scope.data = festivalDataFactory.mainStage.data;
		}
	}
];
},{}],5:[function(require,module,exports){
module.exports = [function(){
	return {
		restrict: 'A',
		link: function($scope, $elem, attrs){
			var object = $elem.find('object')[0];

			function init(){
				var svg = angular.element(object.contentDocument).find('svg');
				if(svg.length){
					svg.css({backgroundPosition: attrs.bgPosition});
				}
			}

			/**
			 * istenért se sikerült angularal, meg jquery-vel ráültetni az eseményeket. megnézzük hogy valaki
			 * állított-e eseményt az onloadra, és ha igen akkor kiszedjük, és az újra rákötött eseményen hívjuk
			 * meg.
			 */
			var oldOnload = (function(){
				return object.onload == null ? function(){} : object.onload;
			})();

			object.onload = function(){
				oldOnload();
				init();
			}
		}
	}
}];
},{}],6:[function(require,module,exports){
module.exports = [function(){
	return {
		restrict: 'A',
		link: function($scope, $elem, attrs){
			var object = $elem.find('object')[0];

			function init(){
				var svg = angular.element(object.contentDocument).find('svg');
				if(svg.length){
					svg.css({backgroundSize: attrs.bgSize});
				}
			}

			/**
			 * istenért se sikerült angularal, meg jquery-vel ráültetni az eseményeket. megnézzük hogy valaki 
			 * állított-e eseményt az onloadra, és ha igen akkor kiszedjük, és az újra rákötött eseményen hívjuk
			 * meg.
			 */
			var oldOnload = (function(){
				return object.onload == null ? function(){} : object.onload;
			})();

			object.onload = function(){
				oldOnload();
				init();
			}
		}
	}
}];
},{}],7:[function(require,module,exports){
module.exports = ['facebookFactory', function(facebookFactory){
	return {
		restrict: 'A',
		scope: {
			facebookCommentUrl: '=facebookComment',
			facebookCommentsNumber: '='
		},
		link: function($scope, $elem, attr){
			var facebookClass = 'fb-comments';
			var commentsWidth = $elem.width();
			var $comments = angular.element('<div class="' + facebookClass + '" data-width="' + commentsWidth + '" data-numposts="' + 5 + '"></div>');
			$elem.append($comments);

			$scope.$watch('facebookCommentUrl', function(newValue){
				if(newValue && newValue.length){
					changeCommentUrl(newValue);
				}
			});

			function changeCommentUrl(url){
				try {
					$comments.attr('data-href', url);
					facebookFactory.FB.XFBML.parse();
				} catch(e) {
					//console.log('facebook api error');
				}
			}
		}
	}
}];
},{}],8:[function(require,module,exports){
module.exports = ['jQuery', function($){
	return {
		restrict: 'A',
		scope: {
			index: '=lenia',
			tabs: '='
		},
		link: function($scope, $elem, attr){
			var ANIMATION_TIME = 300;
			var currentIndex = 0;
			var $container = $($elem).parent();
			var $windowElem = angular.element(window);
			var currentWidth = $windowElem.width();

			setLeniaWidth();

			$scope.$watch('tabs', function(){
				setLeniaWidth();
			});

			$scope.$watch('index', function(newValue){
				var index = parseInt(newValue, 10);

				if(!isNaN(index)){
					handleIndexChange(index);
				}
			});

			function animateLenia(left, cb){
				$($elem).animate({left: left}, ANIMATION_TIME, function(){
					if(typeof cb == 'function'){
						cb();
					}
				});
			}

			function handleIndexChange(newIndex){
				if(newIndex < currentIndex){
					takeARound(function(){
						slideToIndex(newIndex, function(){
							slideCompleted(newIndex);
						});
					});
				} else {
					slideToIndex(newIndex, function(){
						slideCompleted(newIndex);
					});
				}
			}

			function takeARound(cb){
				var containerWidth = $container.width();
				var elemWidth = $elem.width();
				var left = containerWidth + elemWidth;
				animateLenia(left, function(){
					$($elem).css({left: -elemWidth});
					if(typeof cb == 'function'){
						cb()
					}
				});
			}

			function slideToIndex(index, cb){
				var left = index * $elem.width();
				animateLenia(left, cb);
			}

			function slideCompleted(index){
				currentIndex = index;
			}

			function setLeniaWidth() {
				var leniaWidth = $container.width() / $scope.tabs;
				$elem.width(leniaWidth);
			}

			function handleResize() {
				if ( currentWidth != $windowElem.width() ) {
					currentWidth = $windowElem.width();
					setLeniaWidth();

					if(!isNaN($scope.index)){
						handleIndexChange($scope.index);
					}
				}
			}

			angular.element(window).on('resize', handleResize);
		}
	}
}];
},{}],9:[function(require,module,exports){
module.exports = [
	function(){
		return {
			restrict: 'A',
			link: function($scope, $elem, attr){
				var SPOTIFY_BASE_URL = 'https://embed.spotify.com/?uri=';
				attr.$observe('spotify', function(newValue){
					if(newValue && newValue.length){
						var src = SPOTIFY_BASE_URL + newValue;
						$elem.attr('src', src);
					}
				});
			}
		}
	}
];
},{}],10:[function(require,module,exports){
module.exports = ['youtubeFactory', 'buddiesFactory', function(youtubeFactory, buddiesFactory){
	return {
		restrict: 'A',
		scope: {
			playlistId: '@',
			youtubeId: '=youtube',
			buddyId: '@'
		},
		link: function($scope, $elem, attr){
			var player = null;
			var isPlaylist = false;
			var pollingInterval = parseInt(attr.pollingInterval, 10) * 1000;

			createPlayer(getID(), function(){
				setTimeout(function(){
					changePlayerSource($scope.youtubeId);
					startPolling();
				}, 100);
			});

			function getID(){
				var id = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
				if(angular.element('#' + id).length == 0){
					return id;
				} else {
					return getID();
				}
			}

			function createPlayer(id, cb){
				var playerContainer = angular.element('<div id="' + id + '"></div>');
				var playerWidth = $elem.width();

				$elem.append(playerContainer);

				player = new youtubeFactory.YT.Player(id, {
					height: '390',
					width: playerWidth,
					playerVars: {
						controls: '0',
						modestbranding: '1',
						showinfo: '0',
						autoplay: '1'
					},
					events: {
						'onReady': cb,
						'onStateChange': onPlayerStateChange,
						'onError' : onStreamPlayerError
					}
				});
			}

			function changePlayerSource(youtubeId){
					player.loadVideoById(youtubeId);
			}

			function onPlayerError(err){
				//TODO: hibát kezelni
				console.log('Hiba történt lejátszás közben: ', err);
			}

			function onStreamPlayerError(){
				player.loadPlaylist({
					listType: 'playlist',
					list: $scope.playlistId
				});
			}

			function onPlayerStateChange(event) {
				var state = event.target.getPlayerState();

				switch(state){
					case 5:
						event.target.playVideo();
						break;
					default:
						//console.log('stateChanged', state);
						break;
				}
			}

			function startPolling(){
				// console.log('polling');
				buddiesFactory.getBuddyDataById($scope.buddyId).then(function(response){
					var buddyData = response.data;
					//ha épp nincs élő közvetítés az interface szerint
					if(buddyData.status == 'offline'){
						//és éppen nem a fallback lejátszási lista megy
						if(!isPlaylist){
							//akkor elindítjuk
							onStreamPlayerError();
							isPlaylist = true;
						}
					} else {
						//Ha van élő közvetítés az interface szerint, és éppen a lejátszási lista megy
						if(isPlaylist){
							//elindítjuk a streamet
							changePlayerSource(buddyData.youtube_url);
							isPlaylist = false;
						}
					}
					$scope.$parent.buddy = buddyData;
					
					setTimeout(startPolling, pollingInterval);
				}, function(err){
					console.log(err);
				})
			}
		}
	}
}];

},{}],11:[function(require,module,exports){
module.exports = [
	function(){
		return function(array){
			var retValue = [];
			if(array && array.length){
				for(var i = 0; i < array.length; i++){
					var item = array[i];
					var itemDate = (item.date) ? new Date(item.date) : item.from;
					var currentDate = new Date();
					if(itemDate.getFullYear() >= currentDate.getFullYear() && itemDate.getMonth() >= currentDate.getMonth() && itemDate.getDate() >= currentDate.getDate()){
						retValue.push(item);
					}
				}
			}
			return retValue;
		}
	}
];
},{}],12:[function(require,module,exports){
module.exports = [function(){
    return function(instaFeedObject, imageSize){
        var retValue = [];
        var data = instaFeedObject.data;
        var resolution = imageSize || 'standard_resolution';

        if (data && data.length) {
            for (var i = 0; i < data.length; i++) {
                var item = data[i];

                retValue.push({
                    url: item.images[resolution].url,
                    link: item.link
                });
            }
        }

        return retValue;
    }
}];
},{}],13:[function(require,module,exports){
module.exports = [function(){
	return function(array){
		var retValue = [];
		var todayString = new Date().toDateString();
		if(array && array.length){
			for(var i = 0; i < array.length; i++){
				var item = array[i];
				if((item.from) ? item.from.toDateString() : new Date(item.date).toDateString() === todayString){
					retValue.push(item);
				}
			}
		}
		return retValue;
	}
}];
},{}],14:[function(require,module,exports){
module.exports = ['$filter', function($filter){
	return function(array, channelId){
		var retValue = {
			current: null,
			next: null
		};

		if(array && array.length && channelId){
			var currentTime = new Date().getTime();
			var fromToday = $filter('fromTodayFilter')(array);
			var inThisChannel = $filter('filter')(fromToday, {channelId: channelId});
			var orderedByDate = $filter('orderBy')(inThisChannel, 'from');

			for(var i = 0; i < orderedByDate.length; i++){
				var isAfterPlaylist = currentTime <= orderedByDate[i].from.getTime();

				if(isAfterPlaylist){
					retValue.current = orderedByDate[i];
					if(orderedByDate[i + 1]){
						retValue.next = orderedByDate[i + 1];
					}
					break;
				}
			}
		}

		return retValue;
	}
}];
},{}],15:[function(require,module,exports){
module.exports = ['$filter', function($filter){
	return function(array, channelId){
		var retValue = {
			current: null,
			next: null
		};

		if(array && array.length && channelId){
			var currentTime = new Date().getTime();
			var fromToday = $filter('fromTodayFilter')(array);
			var inThisChannel = $filter('filter')(fromToday, {channelId: channelId});
			var orderedByDate = $filter('orderBy')(inThisChannel, '-to');

			for(var i = 0; i < orderedByDate.length; i++){
				var isPlaying = currentTime > orderedByDate[i].from.getTime() && currentTime < orderedByDate[i].to.getTime();
				if(isPlaying){
					retValue.current = orderedByDate[i];
					if(orderedByDate[i - 1]){
						retValue.next = orderedByDate[i - 1];
					}
					break;
				}
			}
		}

		return retValue;
	}
}];
},{}],16:[function(require,module,exports){
module.exports = [function(){
	return function(array){
		var ONE_MINUTE_IN_MS = 60000;
		var ONE_HOUR_IN_MS = 60 * ONE_MINUTE_IN_MS;
		var retValue = [];
		var currentTime = new Date().getTime();
		if(array && array.length){
			for(var i = 0; i < array.length; i++){
				var newItem = {};
				var date = new Date(array[i].Date);
				date.setHours(0);
				var time = new Date(array[i].Time);
				var utcOffset = time.getTimezoneOffset();
				time = new Date(time.getTime() + utcOffset * ONE_MINUTE_IN_MS);
				var hours = time.getHours();
				var minutes = time.getMinutes();

				//TODO be kell tenni azt is hogy mikor kezdődik (12:30) hogy ezt majdd lehessen mutogatni következőként

				newItem.videoId = array[i].VideoID;
				newItem.channelId = array[i].Channel;
				newItem.from = new Date(date.getTime() + (hours * ONE_HOUR_IN_MS) + minutes * ONE_MINUTE_IN_MS);
				newItem.to = new Date(newItem.from.getTime() + array[i].Duration * ONE_MINUTE_IN_MS);
				newItem.eventName = array[i].EventName;
				newItem.LDR = array[i].LDR;
				newItem.stageId = array[i].StageID;
				newItem.streamName = array[i]['Stream_Name'];
				newItem.isActive = currentTime > newItem.from.getTime() && currentTime < newItem.to.getTime();
				newItem.startTime = '' + hours + ':' + (('' + minutes).length == 1 ? '0' + minutes : minutes);
				newItem.niceDate = (array[i].Channel == 3) ? 'Aug. ' + date.getDate() + ', ' : '';

				retValue.push(newItem);
			}
		}
		return retValue;
	}
}];
},{}],17:[function(require,module,exports){
module.exports = ['$http', '$q', function($http, $q){

	var FULL_DATA_URL = '/buddy/api-access/buddy-list';
	var BUDDY_INFO_URL = '/buddy/api-access/buddy/{{id}}';
	var factory = {};

	factory.getData = function(){
		return $http.get(FULL_DATA_URL);
	};


	factory.getBuddyDataById = function(id){
		var url = BUDDY_INFO_URL.replace('{{id}}', id);

		return $http.get(url);
	};
	
	return factory;
}];
},{}],18:[function(require,module,exports){
module.exports = [function(){
	var factory = {
		FB: (typeof FB != 'undefined') ? FB : {},
		onFacebookReady: function(cb){
			if(window.facebookReady === true){
				cb();
			} else {
				window.fbAsyncInit = function () {
					window.facebookReady = true;
					cb();
				};
			}
		}
	};

	return factory;
}];
},{}],19:[function(require,module,exports){
module.exports = [
	function(){
		var factory = null;
		if(typeof window.festivalData != 'undefined'){
			factory = window.festivalData;
		}
		return factory;
	}
];

},{}],20:[function(require,module,exports){
module.exports = [function(){
	var factory = {
		Instafeed: (typeof Instafeed !== 'undefined') ? Instafeed : {}
	};

	return factory;
}];
},{}],21:[function(require,module,exports){
module.exports = ['instaFeedFactory', 'festivalDataFactory', function(instaFeedFactory, festivalDataFactory){

    var factory = {
        create: function(id, callback) {
            if (instaFeedFactory.Instafeed) {
                var parameters = festivalDataFactory.instagram.data[id];

                parameters['clientId'] = festivalDataFactory.instagram.clientId;
                parameters['success'] = callback;

                return new instaFeedFactory.Instafeed(parameters);
            }
        }
    };

    return factory;
}];
},{}],22:[function(require,module,exports){
module.exports = [function(){
	return jq1101;
}];
},{}],23:[function(require,module,exports){
module.exports = [function(){
	var factory =  {
		YT: YT,
		onYouTubeReady: function(cb){
		if(window.youTubeIframeAPIReady === true){
			cb();
		} else {
			window.onYouTubeIframeAPIReady = function () {
				window.youTubeIframeAPIReady = true;
				cb();
			};
		}
	}
	};

	return factory;
}];
},{}]},{},[1]);
